import Image from '@/components/Image';
import CurrencyIcon from '@/components/icons/CurrencyIcon';
import { useTranslation } from 'next-i18next';
import {
  MISPAY_INSTALLMENTS,
  isMispayPromoTotal,
  mispayInstallmentAmount,
} from '@/utils/payment/mispay';

// QA-319: MISPay promo card for the product page and the cart, in the shape
// of the Tamara card (KSA only; the parent gates on the store).
const MISPayWidget = ({ total }) => {
  const { t } = useTranslation('common');
  if (!isMispayPromoTotal(total)) return null;

  return (
    <div className='flex gap-2 rounded-md border bg-white p-2 sm:items-center'>
      <Image
        loading='lazy'
        src='/imgs/checkout/mispaymethod-logo.png'
        className='h-7 w-10 object-contain sm:w-16'
        alt='MISPay'
      />
      <p className='flex flex-wrap items-center gap-1 text-xs leading-5 sm:text-[15px]'>
        {t('mispayPayIn', { installments: MISPAY_INSTALLMENTS })}
        <span className='flex items-center gap-1 whitespace-nowrap font-bold'>
          {mispayInstallmentAmount(total)}
          <CurrencyIcon className='size-3.5' />.
        </span>
      </p>
    </div>
  );
};

export default MISPayWidget;
